import commonService from './common-service';

class InvoiceService {
  async uploadInvoiceFile(params) {
    try {
      const response = await commonService.postToServer('Invoice/Upload', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async generateInvoiceAll(params) {
    try {
      const response = await commonService.postToServer('Invoice/CreateAll?year='+params.year+'&month='+params.month,'');
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  } 
  async generateInvPerParent(params){
    try {
      const response = await commonService.postToServer('Invoice/Create',params);
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }

  }
  async publishList(params){
    try {
      const response = await commonService.postToServer('Invoice/Publish',params);
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }

  }  
  async getInvoices(params){
    try {
      let cndntxt = "";
      if(params?.parent){
        cndntxt +="parent="+params?.parent+"&";
      }
      if(parseInt(params.month)>=0){
        cndntxt +="month="+params?.month+"&";
      }
      if(params?.year){
        cndntxt +="year="+params?.year;
      }
      const response = await commonService.getFromServer('Invoice/Documents?'+cndntxt, "");
      if (response) {
        return response;
      } else {
        throw new Error('Error uploading details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }  
  async deleteInv(drugId){
    try {
      const response = await commonService.deleteToServer('Invoice/Documents/'+drugId, {});      
      if (response) {
        return response;
      } else {
        throw new Error('Error while deleting Invoice. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async reportDownload(id){
    try {
      const response = await commonService.getFromServer('Invoice/PdfFile?id='+id, {});      
      if (response) {
        return response;
      } else {
        throw new Error('Error while downloading. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new InvoiceService();
